import { GetColors } from 'phoenix/theming/Colors';
import { AppColorTheme } from 'phoenix/theming/ColorVariants/AppColorTheme';
import { useAppTheme } from './UseAppTheme';

export const useColors = (): AppColorTheme => {
    const [ appTheme, _] = useAppTheme();
    return GetColors(appTheme);
}